import React, { useCallback } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { FiFile } from 'react-icons/fi'
import {
    format, getMonth, lastDayOfYear, startOfYear, subDays, subYears
} from 'date-fns'

import Yup from '~/services/yup'
import { api, authHeaders } from '~/services/api'

import { downloadRelatorioJasper } from '~/util/file'

import {
    Button, Calendar
} from '~/components/Form'
import Spinner from '~/components/Spinner'

import { Container, ButtonContainer } from './styles'

import rangeDayGif from '~/assets/images/gifs/periodo-dias.gif'

const initialValues = {
    pagamento: ''
}

const validation = Yup.object().shape({
    pagamento: Yup.string().nullable().required('Informe um periodo para a busca.')
})

const nomeRelatorio = 'Relatório de Balanço'

export default function (props) {
    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const {
            pagamento
        } = values

        const inicio = pagamento ? pagamento[0] : null
        const fim = pagamento ? pagamento[1] : null
        const inicioSaldo = getMonth(new Date(inicio)) === 0 ? subYears(new Date(inicio), 1) : new Date(inicio)

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioBalanco',
                parametros: {
                    dataInicio: inicio !== null ? format(new Date(inicio), 'yyyy-MM-dd') : null,
                    dataFim: fim !== null ? format(new Date(fim), 'yyyy-MM-dd') : (inicio !== null) ? format(new Date(inicio), 'yyyy-MM-dd') : null,
                    dataInicioSaldo: getMonth(new Date(inicio)) === 0 ? format(lastDayOfYear(inicioSaldo), 'yyyy-MM-dd 00:00:00') : format(startOfYear(inicioSaldo), 'yyyy-MM-dd 00:00:00'),
                    dataFimSaldo: format(subDays(new Date(inicio), 1), 'yyyy-MM-dd 23:59:59')
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch (e) {
            console.log(e)
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, resetForm
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Calendar
                            name="pagamento"
                            label="Período para busca"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f1' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
